<template>
    <div>
        <form :action="action_url" method="POST" class="validate-form">
            <input type="hidden" name="_token" :value="csrf">
            <div class="clearfix">
                <div class="pull-right clearfix">
                    <input type="submit"
                           class="btn btn-primary inventory_submit"
                           :value="trans('save_button', null)">
                </div>
            </div>
            <br>
            <table class="b-warehouse__bonuses-table">
                <thead>
                    <tr>
                        <th class="col-md-3" v-text="trans('title')"></th>
                        <th class="col-md-1" v-text="trans('now_in_stock')"></th>
                        <th class="col-md-1" v-text="trans('new_quantity')"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="consumable in consumables">
                        <td class="col-md-3">
                            <span v-text="consumable.title"></span>
                        </td>
                        <td class="col-md-1">
                            <span v-text="consumable.available_quantity"> шт.</span>
                        </td>
                        <td class="col-md-1">
                            <input :name="'data[' + consumable.id + '][new_quantity]'"
                                   class="form-control input-sm b-warehouse__new-count"
                                   type="number"
                                   min="0"
                                   step="1"
                                   :value="consumable.available_quantity"
                            >
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="pull-right">
                <br>
                <input type="submit"
                       class="btn btn-primary inventory_submit"
                       :value="trans('save_button', null)"
                >
            </div>
        </form>
    </div>
</template>

<script>
    let Functions = require("../../Functions");

    module.exports = {
        props: ['consumables', 'section', 'translations'],
        data: function () {
            return {
                csrf: '',
                consumables: this.consumables,
                action_url: "/warehouse/" + this.section + "/consumables",
            };
        },
        mounted: function () {
            let token = document.querySelector('#token').getAttribute('content');
            Vue.http.headers.common['X-CSRF-TOKEN'] = token;
            this.csrf = token;
        },
        methods: {
            trans(name, path = 'stock') {
                return Functions.trans(this.translations, name, path);
            }
        }
    };
</script>